"use client";

import { Card } from "@heroui/react";

import { Description, Line, Title } from "./section-heading";
import MainButton from "./main-button";
import MotionCol from "./motion-col";

import { Image } from "@/features/common/components/ui/image";

type PathCardItem = {
  id: string;
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
  imageWidth: number;
  imageHeight: number;
};

type PathCardsClientProps = {
  cards: PathCardItem[];
};

export default function PathCardsClient({ cards }: PathCardsClientProps) {
  return (
    <>
      {cards.map((card) => (
        <Card
          key={card.id}
          className="container flex flex-col items-center gap-8 bg-transparent px-6 py-6 shadow-none md:flex-row md:py-8"
        >
          <MotionCol className="max-w-xl flex-1 justify-center" side="right">
            <Line />
            <Title className="bg-[url(/img/title-bg.png)] bg-size-[100%_100%] bg-center bg-no-repeat p-5">
              {card.title}
            </Title>
            <Description className="pt-3">{card.description}</Description>
            <MainButton
              title={card.id === "public-path" ? "learn more" : "get started"}
            />
          </MotionCol>

          <div className="mt-6 flex w-full max-w-lg flex-1 items-center justify-center gap-3 md:mt-0 md:w-auto">
            <MotionCol>
              <Image
                removeWrapper
                alt={card.imageAlt}
                className="z-0 self-start object-cover p-6 opacity-100 md:p-8"
                height={card.imageHeight}
                src={card.imageSrc}
                width={card.imageWidth}
              />
            </MotionCol>
          </div>
        </Card>
      ))}
    </>
  );
}
